<template>
  <v-app-bar
      tile
      dark
      app
      class="bar"
      color="white"
      height="90"
  >
    <div class="logo-wrapper">
      <img
          class="logo"
          height="60px"
          :src="logoUrl"
          @click="onLogoClick"
      >
    </div>
    <v-spacer></v-spacer>
    <div class="actions text-start">
      <slot name="actions"></slot>
    </div>
    <v-spacer></v-spacer>
    <slot name="right-menu">
      <v-menu
          v-if="!hideMenu"
          transition="slide-y-transition"
          offset-y
          offset-x
          right
          rounded="lg"
          content-class="menuBody"
          offset="35"
          max-width="370"
      >
        <template v-slot:activator="{ props }">
          <v-btn
              class="action"
              color="primary"
              elevation="0"
              v-bind="props"
          >
            {{ $t(menuName) }}
            <v-icon right>mdi-menu</v-icon>
          </v-btn>
        </template>
        <div class="menu">
          <slot name="menu"></slot>
        </div>
      </v-menu>
    </slot>
  </v-app-bar>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    logoUrl: {
      type: String,
      required: true,
    },
    menuName: {
      type: String,
      default: 'Меню'
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
    onLogoClick: {
      type: Function,
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
:slotted(.actions),
.actions {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 20px;
  flex-grow: 7;

  :slotted(.action) {
    border-radius: 6px;
    font-family: var(--primary-font-family-name);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    text-transform: none;
    letter-spacing: normal;
    padding-top: 12px;
    padding-bottom: 12px;
    height: auto;
  }

  :slotted(.actionLink) {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    text-decoration: none;
  }

  :slotted(.actionLink:hover) {
    color: rgb(var(--black-color));
  }

  :slotted(.currentAction) {
    text-decoration-line: underline;
    text-underline-offset: 5px;
  }
}

:slotted(.action),
.action {
  border-radius: 6px !important;
  font-family: var(--primary-font-family-name);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  text-transform: none;
  letter-spacing: normal;
  padding-top: 12px;
  padding-bottom: 12px;
  height: auto !important;
}

.menuBody {
  box-shadow: 0 1px 5.5px rgba(var(--gold-color), 0.5);
  border-radius: 20px !important;
}

:slotted(.menu),
.menu {
  display: inline-flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  border-radius: 20px;
  background: rgb(var(--primary-color));
  box-shadow: 0 1px 6px rgba(var(--gold-color), 0.55);
  width: 100%;

  :slotted(.action) {
    width: 100%;
    display: flex;
    padding: 0;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    :slotted(.actionTitle),
    :slotted(.actionLink) {
      color: rgb(var(--gold-color));
      background: rgb(var(--primary-color));
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    :slotted(.actionLink) {
      color: rgba(var(--gold-color), 0.7);
      text-decoration: none;
    }

    :slotted(.actionTitle:hover),
    :slotted(.actionLink:hover) {
      color: rgba(var(--gold-color), 0.5);
    }
  }

  :slotted(hr.actionsDivider) {
    display: block;
    width: 100%;
    border: none;
    border-top: 1px solid rgba(var(--gold-color), 0.50);
  }
}

.bar {
  padding: 0 16px !important;
  box-shadow: 0 1px 8px rgba(var(--shadow-color), 0.15) !important;
}

.logo-wrapper {
  width: 210px
}

.logo {
  cursor: pointer;
}

</style>